<template>
  <div class="">
    <span v-if="item" :class="trueClass">
      {{ trueLabel }}
    </span>
    <div v-else>
      <span v-if="showFalse" :class="falseClass">{{ falseLabel }} </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { cva } from 'class-variance-authority';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t: $t } = useI18n({ useScope: 'global' });
const props = withDefaults(
  defineProps<{
    item?: boolean | number;
    textTrue?: string;
    textFalse?: string;
    showFalse?: boolean;
    color?: 'green' | 'red' | 'blue';
  }>(),
  {
    showFalse: true,
  }
);

const trueLabel = computed(() => props.textTrue ?? $t('baseObject.isActive'));
const falseLabel = computed(() => props.textFalse ?? $t('material.inactive'));

const trueClass = computed(() => {
  const color = props.color || 'green';
  return cva('border text-xs font-normal mr-2 px-2.5 py-0.5 rounded-full', {
    variants: {
      color: {
        green: 'bg-green-50 text-green-500 border-green-200',
        red: 'bg-red-50 text-red-500 border-red-200',
        blue: 'bg-blue-50 text-blue-500 border-blue-200',
      },
    },
  })({
    color: color,
  });
});

const falseClass = computed(() => {
  if (props.color) {
    return cva('border text-xs font-normal mr-2 px-2.5 py-0.5 rounded-full', {
      variants: {
        color: {
          green: 'bg-green-50 text-green-500 border-green-200',
          red: 'bg-red-50 text-red-500 border-red-200',
          blue: 'bg-blue-50 text-blue-500 border-blue-200',
        },
      },
    })({
      color: props.color,
    });
  } else {
    return 'bg-gray-100 text-gray-500 border-gray-200 border text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full';
  }
});
</script>
